import { gql } from "@apollo/client";

const GET_COMBO_SUSPENSION_MOTIVO = gql`
    query comboSuspensionMotivo{
        comboSuspensionMotivo{
            idSuspensionMotivo
            descripcion
        }
    }
`;

export default GET_COMBO_SUSPENSION_MOTIVO;

const adaptSuspensionMotivo = (motivo) => {
  return {
    id: motivo?.idSuspensionMotivo,
    displayName: motivo?.descripcion
  };
};

export const adaptComboSuspensionMotivoArray = (comboSuspensionMotivo) => {
  return structuredClone(comboSuspensionMotivo)?.
  map((motivo) => adaptSuspensionMotivo(motivo));
};